import React, { useEffect } from "react";
import BenefitsImg from '../Images/Benefits.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function Benefits() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={BenefitsImg} alt="Benefits" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Benefits</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Architetive Designs not only allows you to work with a range of talented individuals on exciting projects across the world but also provides access to a host of benefits. We are committed to the development of our people and providing them benefits and initiatives to support their professional and personal lives.
                    </p>
                </div>

                <div className="mb-8">
                    <h1 className="text-2xl font-semibold mb-3">Learning & Development</h1>
                    <div className="border mb-4" />
                    <p className="mb-6 text-gray-800 text-base md:text-lg font-light tracking-wider">
                        Working at Architetive Designs offers an opportunity to build a rewarding career, with first-class training and development available to everyone. As a global practice with offices around the world, we offer development opportunities through international assignments to those interested in pursuing an international career.
                    </p>
                </div>

                <div>
                    <h1 className="text-xl mb-4 text-gray-500">Explore</h1>
                    <div className="flex flex-col space-y-4 mb-8">
                        <div className="flex flex-row space-x-4 ">
                            <Link to='/careers/vacancies'>
                                <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Vacancies</button>
                            </Link>
                            <Link to='/careers/early-careers'>
                                <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Early Careers</button>
                            </Link>
                        </div>
                        <div>
                            <Link to='/people/equity-diversity-and-inclusion'>
                                <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Equity, Diversity and Inclusion</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Benefits;